import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/skeleton/downloadsItem.svg")